import { type IconProps, Stroke } from "./base";

/** How something stands: done, locked, waiting, busy, paused, a notice. */

export function CheckIcon({ strokeWidth = 2.2, ...props }: IconProps) {
    return (
        <Stroke strokeWidth={strokeWidth} {...props}>
            <path d="M5 12.5l4.5 4.5L19 7.5" />
        </Stroke>
    );
}

export function LockIcon({ strokeWidth = 2.2, ...props }: IconProps) {
    return (
        <Stroke strokeWidth={strokeWidth} {...props}>
            <rect x="5" y="11" width="14" height="10" rx="2" />
            <path d="M8 11V7a4 4 0 0 1 8 0v4" />
        </Stroke>
    );
}

export function ClockIcon({ strokeWidth = 2, ...props }: IconProps) {
    return (
        <Stroke strokeWidth={strokeWidth} {...props}>
            <circle cx="12" cy="12" r="9" />
            <path d="M12 7v5l3 2" />
        </Stroke>
    );
}

/** The circled "i" of a line that explains: where the envoy's matches show. */
export function InfoIcon({ strokeWidth = 1.8, ...props }: IconProps) {
    return (
        <Stroke strokeWidth={strokeWidth} {...props}>
            <circle cx="12" cy="12" r="9" />
            <path d="M12 11v5.5M12 7.5v.5" />
        </Stroke>
    );
}

/** The circled mark of a notice: the exhausted banner, the out-of-tailors note. */
export function AlertIcon({ strokeWidth = 2, ...props }: IconProps) {
    return (
        <Stroke strokeWidth={strokeWidth} {...props}>
            <circle cx="12" cy="12" r="9" />
            <path d="M12 7v6M12 16.5v.5" />
        </Stroke>
    );
}

/** The speech mark over a question left to the person. */
export function QuestionIcon({ strokeWidth = 1.8, ...props }: IconProps) {
    return (
        <Stroke strokeWidth={strokeWidth} {...props}>
            <path d="M12 3a9 9 0 0 1 0 18H5l1.6-2.9A9 9 0 0 1 12 3Z" />
            <path d="M9.8 9.6a2.3 2.3 0 1 1 3.5 2c-.8.5-1.3 1-1.3 1.9M12 16v.1" />
        </Stroke>
    );
}

/** The busy arc that turns while something saves. */
export function SpinnerIcon({ strokeWidth = 2.6, className = "size-4", ...props }: IconProps) {
    return (
        <Stroke strokeWidth={strokeWidth} className={`animate-spin ${className}`} {...props}>
            <path d="M12 3a9 9 0 1 0 9 9" />
        </Stroke>
    );
}

/** The play glyph, filled, for Resume. */
export function PlayIcon({ className = "size-4", ...props }: IconProps) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
            className={className}
            {...props}
        >
            <path d="M7 4.5v15l12-7.5z" />
        </svg>
    );
}

/** The pause glyph, filled, as the hold banner and the paused envoy show it. */
export function PauseIcon({ className = "size-4", ...props }: IconProps) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
            className={className}
            {...props}
        >
            <rect x="6" y="4" width="4" height="16" rx="1.2" />
            <rect x="14" y="4" width="4" height="16" rx="1.2" />
        </svg>
    );
}

/** Upgrade: a filled bolt. */
export function BoltIcon({ strokeWidth = 1.6, ...props }: IconProps) {
    return (
        <Stroke strokeWidth={strokeWidth} fill="currentColor" {...props}>
            <path d="M13 2L4 14h7l-1 8 9-12h-7l1-8z" />
        </Stroke>
    );
}

/** Find and tailor: two sparks. */
export function SparkIcon({ strokeWidth = 2, ...props }: IconProps) {
    return (
        <Stroke strokeWidth={strokeWidth} {...props}>
            <path d="M12 3l1.8 4.6L18.5 9.5l-4.7 1.9L12 16l-1.8-4.6L5.5 9.5l4.7-1.9zM19 15l.9 2.1L22 18l-2.1.9L19 21l-.9-2.1L16 18l2.1-.9z" />
        </Stroke>
    );
}
